// extracted by mini-css-extract-plugin
export var button = "_p2-0";